import { t } from "i18next";
import { ROWS_PER_PAGE_OPTIONS, DEFAULT_ROWS_PER_PAGE } from "./TableConfig";

const options = {
  filterType: "checkbox",
  filter: false,
  responsive: "standard",
  print: false,
  download: false,
  selectableRows: "none",
  rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS,
  rowsPerPage: DEFAULT_ROWS_PER_PAGE,
  searchAlwaysOpen: true,
  displayRows: false,
  textLabels: {
    body: {
      noMatch: t("NoData_Page"),
      toolTip: t("Sort"),
      columnHeaderTooltip: (column) => `${t("Sort")} ${column.label}`,
    },
    pagination: {
      next: t(""),
      previous: t(""),
      rowsPerPage: t(""),
    },

    viewColumns: {
      title: t("ShowColumn"),
    },
  },
};

export default options;
